// extracted by mini-css-extract-plugin
export default {"root":"cardMask_root__-u2+T"};